import { UIBetSettingsType, UIDenomDisplayType, UIElements, UISettingsButtons } from "gameiom/wrapper/wrapper-data";

export enum JackpotTiers {
    GRAND,
    MAJOR,
    MINOR,
    MINI
}

export const JackpotTierKeys = new Map<string, JackpotTiers>([
    ["mini", JackpotTiers.MINI],
    ["minor", JackpotTiers.MINOR],
    ["major", JackpotTiers.MAJOR],
    ["grand", JackpotTiers.GRAND]
]);

export const JackpotTierNames = new Map<JackpotTiers, string>([
    [JackpotTiers.MINI, "mini"],
    [JackpotTiers.MINOR, "minor"],
    [JackpotTiers.MAJOR, "major"],
    [JackpotTiers.GRAND, "grand"]
]);

class GameiomModel {
    public url: string;
    public sessionToken: string;
    public username: string;
    public rtp: string;
    public providerId: number;
    public operatorId: number;
    public gameId: number;
    public language: string;
    public currency: string;
    public callbackUrl: string;
    public jurisdiction: string;
    public displayCurrency: boolean;
    public disableSpinSkip: boolean;
    public enableForcing: boolean;
    public displayMaxBet: boolean;
    public displayClock: boolean;
    public denomDisplay: string = UIDenomDisplayType.denom;
    public betSettings: string = UIBetSettingsType.lines // Adding this to default the game to a valid bet menu configuration.;
    public hideBalance = false;
    public hideBet = true;
    public hideDenom = true;
    public hideJackpotWording: boolean;
    public jackpotAmounts: Map<JackpotTiers, number>;
    public removeFromCurrencyString: string;
    public displayWholeStakeAsDecimal = true;
    public wholeNumberCurrencies: string[];
    public disableSpaceToSpin: boolean;
    public displayType: string;
    public hideEnableSoundsPrompt: boolean;
    public displayStopOnFeatureButton: boolean;
    public autoplayStopOnFeatureOverideSet: boolean;
    public preSelectAutoplayOptions = true;
    public enabledSettingsButtons: string[] = [];
    public slamStop: boolean;
    public isSocial = false;

    public displayButtons: Map<UIElements, boolean> = new Map<UIElements, boolean>([
        [UIElements.homeButton, true],
        [UIElements.depositPageButton, false],
        [UIElements.accountsButton, false]
    ] as any);

    protected readonly minimumNumSettingsOptions = 2;

    public shouldDisplayCurrencyAsWholeNumber(): boolean {
        return (
            gameiomModel.wholeNumberCurrencies != null &&
            gameiomModel.wholeNumberCurrencies.find((currency) => currency === gameiomModel.currency) != null
        );
    }

    public shouldDisplayCredits(): boolean {
        return !this.displayCurrency || this.isSocial;
    }
    
    public shouldDisplaySettingsButton(): boolean {
        return this.enabledSettingsButtons.length >= this.minimumNumSettingsOptions;
    }
}

export const gameiomModel = new GameiomModel();
